module.exports = __webpack_public_path__ + "static/media/8OLA32.8f61b058.jpg";